export enum VerifyType {
  LOGIN = "LOGIN",
  SIGN_UP = "SIGN_UP",
  RESET_PASS = "RESET_PASS",
}

export enum Captcha {
  LOGIN = "LOGIN",
  REGISTER = "REGISTER",
  UPDATE_PASSWORD = "UPDATE_PASSWORD",
}

export enum LoginType {
  PASSWORD = "PASSWORD",
  EMAIL_CODE = "EMAIL_CODE",
}

export enum CookieType {
  Required = "Required",
  Personalization = "Personalization",
  Marketing = "Marketing",
  Analytics = "Analytics",
}

export enum ThirdLogin {
  Google = "Google",
  Facebook = "Facebook",
}

export enum Event_Name {
  login_click = "login_click",
  login_close = "login_close",
  login_email_submit = "login_email_submit",
  login_submit = "login_submit",
  register_submit = "register_submit",
  oauth_attempt = "oauth_attempt",
  oauth_result = "oauth_result",
}

export enum Login_Click {
  header_sign_in = "header_sign_in",
  cart_sign_in = "cart_sign_in",
  order_sign_in = "order_sign_in",
  pdp_login_to_checkout = "pdp_login_to_checkout",
  checkout_login_to_checkout = "checkout_login_to_checkout",
}

export enum Login_Close {
  register = "register",
  begin = "begin",
  password_login = "password_login",
  code_login = "code_login",
  third_party_auth = "third_party_auth",
}

export enum Login_Submit_Method {
  password = "password",
  code = "code",
}

export enum Submit_Status {
  success = "success",
  fail = "fail",
}

export enum Fail_Reason {
  user_cancelled = "user_cancelled",
  token_expired = "token_expired",
  network_error = "network_error",
}
